import React, { FC } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { CurrencyInput } from '@eika/currency-input';
import { ButtonToggles } from '@eika/radio-button';

import { ValgtWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { LeieinntekterFormData } from './leieinntekter';

const LeieinntekterSkattepliktige: FC = () => {
    const { leieinntekt, button, validationMessage } = useTranslation();
    const {
        setValue,
        control,
        formState: { errors },
    } = useFormContext<LeieinntekterFormData>();
    const harSkattepliktigeLeieinntekter = useWatch({ name: 'harSkattepliktigeLeieinntekter', control });
    const skattepliktige = useWatch({ name: 'skattepliktige', control });

    const onChangeSkattepliktige = (value: ValgtWeb) => {
        if (value === ValgtWeb.NEI) {
            setValue('skattepliktige', null, { shouldValidate: true, shouldDirty: true });
        }
        setValue('harSkattepliktigeLeieinntekter', value, { shouldValidate: true });
    };

    return (
        <>
            <Controller
                name="harSkattepliktigeLeieinntekter"
                control={control}
                rules={{
                    validate: {
                        ikkeValgtSkattepliktigeLeieinntekter: (value: ValgtWeb) => value !== ValgtWeb.IKKE_VALGT,
                    },
                }}
                render={({ field: { value } }) => (
                    <ButtonToggles
                        label={leieinntekt.toggelsHarSkattepliktigLeieinntekt}
                        data-track-id="kreditt-boliglaan-leieinntekt-valg-skattepliktige"
                        data-track-linkname={value}
                        onChange={(value) => onChangeSkattepliktige(value as ValgtWeb)}
                        selectedOption={value}
                        options={[
                            { label: button.ja, value: ValgtWeb.JA },
                            { label: button.nei, value: ValgtWeb.NEI },
                        ]}
                        errorMessage={
                            errors.harSkattepliktigeLeieinntekter?.type === 'ikkeValgtSkattepliktigeLeieinntekter'
                                ? `${validationMessage.requiredChoose}`
                                : ''
                        }
                    />
                )}
            />
            {harSkattepliktigeLeieinntekter === ValgtWeb.JA && (
                <Controller
                    name="skattepliktige"
                    control={control}
                    rules={{
                        required: `${validationMessage.requiredValue}`,
                    }}
                    render={({ field: { onChange } }) => (
                        <CurrencyInput
                            name="skattepliktige"
                            label={leieinntekt.labelSkattepliktigLeieinntekt}
                            className="max-width-200"
                            placeholder=""
                            type="tel"
                            error={errors.skattepliktige?.message}
                            value={skattepliktige || ''}
                            onValueChange={(v) => onChange(v.value)}
                        />
                    )}
                />
            )}
        </>
    );
};

export default LeieinntekterSkattepliktige;
